import { render, staticRenderFns } from "./CvReferences.vue?vue&type=template&id=610020b5&scoped=true"
import script from "./CvReferences.vue?vue&type=script&lang=js"
export * from "./CvReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610020b5",
  null
  
)

export default component.exports